/**
 * @author Evgenij Tyan
 * @version 1.0.1
 * @since 1.0.0
 */
import produce from 'immer';
import { Reducer } from 'redux';

import { TExtFilterConstructor } from '../actions/extFilterConstructorActions';
import {
    SET_EXTFILTER_ID,
    SET_EXTFILTER_ID_FAILED,
    SET_EXTFILTER_ID_SUCCESSFUL,
    SET_EXTFILTER_ITEM,
    SET_EXTFILTER_ITEM_FAILED,
    SET_EXTFILTER_ITEM_SUCCESSFUL,
} from '../constants/extFilterConstructorConstants';
import { IExtFilterItem } from '../types/extFilterTypes';

/**
 * @description Filter constructor state
 * @interface IExtFilterConstructorInitialState
 * @property {string} id - id of the selected filter
 * @property {IExtFilterItem[]} items - items of the selected filter
 */
export interface IExtFilterConstructorInitialState {
    id: string;
    items: IExtFilterItem[];
}

const initialState: IExtFilterConstructorInitialState = {
    id: '',
    items: [{
        operation: null,
    }],
};

/**
 * Reducer for control external filter
 */
const extFilterConstructorReducer: Reducer<IExtFilterConstructorInitialState, TExtFilterConstructor> =
    (state: IExtFilterConstructorInitialState = initialState, action: TExtFilterConstructor) =>
    produce(state, (draft) => {
        switch (action.type) {
            // SET EXT FILTER
            case SET_EXTFILTER_ID:
                break;
            case SET_EXTFILTER_ID_SUCCESSFUL:
                draft.id = action.payload;
                break;
            case SET_EXTFILTER_ID_FAILED:
                break;

            // SET EXT FILTER ITEM
            case SET_EXTFILTER_ITEM:
                break;
            case SET_EXTFILTER_ITEM_SUCCESSFUL:
                draft.items = action.payload;
                break;
            case SET_EXTFILTER_ITEM_FAILED:
                break;
            default:
                break;
        }
    });

export default extFilterConstructorReducer;
